/** @format */

import React, { FunctionComponent } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { PlatformIccidMsisdnIpPoolReducerAction, PlatformIccidMsisdnIpPoolReducerType } from '../../modules/iccid/PlatformIccidMsisdnIpPoolReducer';
import { useDispatch } from 'react-redux';
import { ImsiChangeRmoTypeAdvance } from '../Storage/imsi/ImsiChangeRmoTypeAdvance';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';

type RmoType = {};

export const Rmo: FunctionComponent<RmoType> = (): React.ReactElement => {
    const dispatch = useDispatch();

    const changeIndicatedRange = (): void => {
        dispatch({
            type: PlatformIccidMsisdnIpPoolReducerAction.INDICATED_RANGE_CHANGE_OPEN_DIALOG_ADVANCED,
            openChangeIndicateRangeAdv: true,
        } as PlatformIccidMsisdnIpPoolReducerType);
    };

    return (
        <GridContainer>
            <GridItem xs={12}>
                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_ICCID_RANGE_UPDATE) && (
                    <CustomTextButtom
                        callback={changeIndicatedRange}
                        callbackParam={{}}
                        label="pools:sim.change_rmo_model"
                        size="sm"
                    />
                )}
            </GridItem>
            <GridItem xs={12}>
                <ImsiChangeRmoTypeAdvance />
            </GridItem>
        </GridContainer>
    );
};
